import {
    IAssistenciaTecnicaMapeado,
    IFiltroAtendimentos,
} from "../../../Interfaces/AssistenciaTecnica/Atendimento/AtendimentoInterfaces";
import {
    ExportarExcelAssistenciaTecnicaService,
    ListarAtendimentosAssisTecService,
    RetornarUsuarioResponsavelEAcompanhamentoServices,
} from "../../../Services/AssistenciaTecnica/GestaoDeAtendimentos/GestaoDeAtendimentosServices";
import { ValidationErr } from "../../../Validations/ValidationError";
import { Controller } from "../../Controller";

export async function ListarAtendimentosAssisTecController(
    data: IFiltroAtendimentos,
    pagina: number,
    SEG_ATENDIMENTOS: string
) {
    const response = await ListarAtendimentosAssisTecService(
        data,
        pagina,
        SEG_ATENDIMENTOS
    )
        .then((response) => {
            return {
                NR_CASOS: response.data.NR_CASOS,
                NR_CASOS_EM_ATRASO: response.data.NR_CASOS_EM_ATRASO,
                NR_CASOS_EM_DIA: response.data.NR_CASOS_EM_DIA,
                ATENDIMENTOS: response.data.Atendimentos?.map((atendimento) => {
                    return {
                        ...atendimento,
                        AssisTec: {
                            DATA_ULTIMA_VISITA_TECNICO:
                                atendimento.DATA_ULTIMA_VISITA_TECNICO,
                            DS_CATEGORIA_ATENDIMENTO_COMP:
                                atendimento.DS_CATEGORIA_ATENDIMENTO_COMP,
                            DS_ETAPA: atendimento.DS_ETAPA,
                            DS_INDICADOR: atendimento.DS_INDICADOR,
                            DS_MOTIVO_CANCELAMENTO:
                                atendimento.DS_MOTIVO_CANCELAMENTO,
                            DS_TECNICO_RESPONSAVEL:
                                atendimento.DS_TECNICO_RESPONSAVEL,
                            DS_TIPO_CASO: atendimento.DS_TIPO_CASO,
                            DT_SLA: atendimento.DT_SLA,
                            DT_SLO: atendimento.DT_SLO,
                            FL_CASO_RECORRENTE: atendimento.FL_CASO_RECORRENTE,
                            FL_GARANTIA: atendimento.FL_GARANTIA,
                            FL_SINCRONIZADO: atendimento.FL_SINCRONIZADO,
                            NR_DIAS_ATRASO: atendimento.NR_DIAS_ATRASO,
                            NR_DIAS_ATRASO_SLO: atendimento.NR_DIAS_ATRASO_SLO,
                            NR_IMPACTO: atendimento.NR_IMPACTO,
                            NR_URGENCIA: atendimento.NR_URGENCIA,
                        },
                        DS_ATENDENTE: atendimento.USUARIO_RESPONSAVEL,
                        DS_CANAL_ATENDIMENTO:
                            atendimento.DS_TIPO_CANAL_ATENDIMENTO,
                        DS_STATUS_CASO: atendimento.DS_STATUS_SOLICITACAO,
                        DS_CASO: atendimento.DS_CASO,
                        DT_FIM: atendimento.DT_FIM,
                        DT_INICIO: atendimento.DT_INICIO,
                        ID_CASO: atendimento.ID_CASO,
                        NR_PAGINAS: atendimento.NR_PAGINAS,
                        CONTA: {
                            DS_CONTATO: atendimento.DS_CONTATO,
                            DS_EMAIL: [],
                            DS_NOME: atendimento.DS_CONTA,
                            ID_CONTATO: 0,
                            NR_CPF: "",
                            NR_TELEFONE: [],
                        },
                        PRODUTO: {
                            DS_EMPREENDIMENTO: atendimento.DS_PRODUTO_COMP,
                            ID_EMPREENDIMENTO: atendimento.ID_PRODUTO,
                            UNIDADE: {
                                DS_UNIDADE: "unidade",
                                ID_UNIDADE: 0,
                            },
                        },
                        QTD_HISTORICOS: 0,
                    } as IAssistenciaTecnicaMapeado;
                }),
            };
        })
        .catch((err) => {
            ValidationErr(err);
            throw err;
        });

    return response;
}

export async function RetornarUsuarioResponsavelEAcompanhamentoController(
    idCaso: number
) {
    return Controller(
        RetornarUsuarioResponsavelEAcompanhamentoServices(idCaso)
    );
}

export async function ExportarExcelAssistenciaTecnicaController(
    SEG_ATENDIMENTOS: string,
    requestBody: IFiltroAtendimentos
) {
    return Controller(
        ExportarExcelAssistenciaTecnicaService(SEG_ATENDIMENTOS, requestBody)
    );
}

export async function ListarAtendimentosAssisTecTransferirController(
    data: IFiltroAtendimentos,
    pagina: number,
    SEG_ATENDIMENTOS: string
) {
    return Controller(
        ListarAtendimentosAssisTecService(data, pagina, SEG_ATENDIMENTOS, true)
    );
}
